import { render } from "./SmsOptInPage.vue?vue&type=template&id=21845adc&scoped=true"
import script from "./SmsOptInPage.vue?vue&type=script&lang=js"
export * from "./SmsOptInPage.vue?vue&type=script&lang=js"

import "./SmsOptInPage.vue?vue&type=style&index=0&id=21845adc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21845adc"]])

export default __exports__